import { useNavigate, useParams } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { useTelemedicineSession, useSessionParticipants } from '@/hooks/telemedicine';
import { Button } from '@/components/ui/Button';
import { ParticipantsList } from '@/components/telemedicine';

export function PatientConsultationPage() {
  const navigate = useNavigate();
  const { sessionId } = useParams<{ sessionId: string }>();
  const { user } = useAuth();

  const { data: session, isLoading } = useTelemedicineSession(sessionId);
  const { data: participants = [] } = useSessionParticipants(sessionId);

  if (isLoading) {
    return <div className="container py-12 text-center text-gray-500">Carregando...</div>;
  }

  if (!session) {
    return <div className="container py-12 text-center text-gray-500">Sessão não encontrada</div>;
  }

  const isPatient = user?.id === session.patientId;

  if (!isPatient) {
    return (
      <div className="container max-w-2xl py-12 text-center">
        <div className="bg-red-50 border border-red-200 rounded-xl p-6">
          <h1 className="text-xl font-bold text-red-900">Acesso negado</h1>
          <Button onClick={() => navigate('/dashboard')} className="mt-4">Voltar</Button>
        </div>
      </div>
    );
  }

  const isWaitingForDoctor = session.status === 'CREATED' || session.status === 'WAITING';

  return (
    <div className="container max-w-3xl py-8">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900">Sua Consulta</h1>
        <p className="text-gray-500 mt-1">Aguardando início</p>
      </div>

      <div className="bg-white rounded-xl border border-gray-200 p-6 space-y-5">
        {isWaitingForDoctor && (
          <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 text-center">
            <div className="animate-pulse text-2xl mb-2">⏳</div>
            <p className="text-sm text-yellow-900">
              Aguardando o médico iniciar a consulta...
            </p>
          </div>
        )}

        <div>
          <h2 className="font-semibold text-gray-900 mb-3">Participantes</h2>
          <ParticipantsList participants={participants} localUserId={user?.id} />
        </div>

        <div className="flex gap-2">
          {session.status === 'IN_PROGRESS' || session.status === 'CONNECTED' ? (
            <Button onClick={() => navigate(`/telemedicine/video/${session.id}`)}>
              Entrar na Consulta
            </Button>
          ) : (
            <Button variant="outline" disabled>
              Aguardando início
            </Button>
          )}
          <Button variant="outline" onClick={() => navigate(`/telemedicine/waiting/${session.appointmentId}`)}>
            Ir para Sala de Espera
          </Button>
        </div>
      </div>
    </div>
  );
}